import { Chorus, Context as AudioContext } from 'tone'

export function createMasterChorus(context: AudioContext): Chorus {
  const chorus = new Chorus({ wet: 1, context })
  return chorus
}
